<i2a-resource-nodata
*ngIf="resourceProfile && resourceProfile.delegates.length == 0 && resourceProfile.permissions.length == 0 && resourceProfile.filterRules.length == 0">
</i2a-resource-nodata>
